import { ContentSection } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { getTimeClass } from '@mews-commander/utils';
import { CentralPolicyFields } from '../../../../../../../rateGroups/components/forms/fields';
import { useSelectedService } from '../hooks';

export const DefaultPolicySection = () => {
    const selectedService = useSelectedService();

    return (
        <ContentSection
            title={lt('RateGroupDefaultPolicySectionTitle')}
            description={lt('RateGroupDefaultPolicySectionDescription')}
            spacing="300"
        >
            <CentralPolicyFields bookablePeriod={selectedService ? getTimeClass(selectedService) : undefined} />
        </ContentSection>
    );
};
